import { isWX, isMQQ, isFudaoApp, getAppVersion, getSafariVer } from './util_04_ua';

function emulatePageShow(cb) {
  var lastInterval = Date.now();

  function intervalHeartbeat() {
    var now = Date.now();
    var diff = now - lastInterval - 200;
    lastInterval = now;

    if (diff > 1000 && cb) {
      cb();
    }

    setTimeout(intervalHeartbeat, 200);
  }

  intervalHeartbeat();
}
/**
 * @description 部分手机，`'webkitvisibilitychange' in document === false`
 * 但是是支持 `document.addEventListener('webkitvisibilitychange')` 的
 * @example
 * // ref https://stackoverflow.com/a/2877424
 * // payton 测试了兼容性，请继续补充
 * |-----------+----------+------------------|
 * | 浏览器    | pageshow | visibilitychange |
 * |-----------+----------+------------------|
 * | ios  微信 | y        | n                |
 * |-----------+----------+------------------|
 * | ios  自带 | y        | n                |
 * |-----------+----------+------------------|
 * | vivo 微信 | ?        | ?                |
 * |-----------+----------+------------------|
 * | vivo 自带 | n        | y                |
 * |-----------+----------+------------------|
 * | 魅族 微信 | y        | n                |
 * |-----------+----------+------------------|
 * | 魅族 自带 | n        | n                |
 * |-----------+----------+------------------|
 * @memberof module:bom
 * @param {function} listener 监听的函数
 * @return {null}
 */


function addPageShowListener() {
  var listener = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var isAndroid = window.mqq && window.mqq.android;

  if (isFudaoApp()) {
    if (window.mqq && window.mqq.iOS && getAppVersion() >= 6) {
      window.mqq.removeEventListener('viewWillAppear');
      window.mqq.addEventListener('viewWillAppear', function () {
        listener();
      });
    } else if (window.mqq && window.mqq.android) {
      // android
      window.mqq.removeEventListener('onWebPageResume');
      window.mqq.addEventListener('onWebPageResume', function () {
        listener();
      });
    } else {
      document.addEventListener('webkitvisibilitychange', function () {
        if (document.hidden === false) {
          listener();
        }
      }, false);
    }
  } else if (isMQQ()) {
    // 手机QQ
    document.addEventListener('qbrowserVisibilityChange', function (e) {
      if (!e.hidden) {
        listener();
      }
    });
  } else if (isWX()) {
    // 微信或浏览器
    window.addEventListener('pageshow', function () {
      listener();
    });
  } else if (isAndroid) {
    var f = function f(e) {
      var hidden = document.hidden === false || e.hidden === false;

      if (hidden) {
        listener();
      }
    }; // android visibilitychange 的行为是正确的，历史返回 android 会触发，ios 不会


    if ('onvisibilitychange' in document) {
      document.addEventListener('visibilitychange', f);
    } else {
      document.addEventListener('webkitvisibilitychange', f);
    }
  } else if (getSafariVer()) {
    emulatePageShow(listener);
  } else {
    // eslint-disable-next-line no-inner-declarations
    var handleVisibilityChange = function handleVisibilityChange() {
      if (!document[hidden]) {
        listener();
      }
    };

    var hidden;
    var visibilityChange;

    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }

    document.addEventListener(visibilityChange, handleVisibilityChange, false);
  }
} // eslint-disable-next-line import/prefer-default-export


export { addPageShowListener };